import React from "react"
import Layout from "../layouts/en"
import SEO from "../components/seo"
import {Container, Row, Col, Form} from "react-bootstrap"
import axios from "axios"
import { toast } from "react-toastify"
import { API_ROOT } from "gatsby-env-variables"
import aboutImg from "../assets/images/header.jpg";
import {Link} from "gatsby";

class contactPage extends React.Component {
  state = {
    email: "",
    subject: "",
    message: "",
    address: "",
    companyEmail: [],
    phone: [],
    mapSrc: "",
    errors: {
      email: "",
      subject: "",
      message: ""
    }
  }
  componentDidMount(){
    axios.get(API_ROOT+`/api/v1/settings`)
      .then( (response) => {
        if(response && response.data && response.data.data){
          this.setState({
            address: response.data.data.address_en,
            companyEmail: response.data.data.email_en,
            phone: response.data.data.phone_en,
            manager: response.data.data.manager_en,
            mobile: response.data.data.mobile_en,
            mapSrc: "https://maps.google.com/maps?q="+response.data.data.latitude+","+response.data.data.longitude+"&t=&z=13&ie=UTF8&iwloc=&output=embed"
          })
        }

      })
      .catch(function (error) {
      });
  }
  handleInputChange = event => {
    const target = event.target;
    const name = target.name;
    let value = target.value;
    this.setState({
      [name]: value
    })
  }
  validateForm = () => {
    let validate = false;
    let errors = this.state.errors;
    if(this.state.email.trim() === ''){
      errors.email = 'Required Filed';
      validate = false;
    } else {
      errors.email = '';
      validate = true;
    }
    if(this.state.subject.trim() === ''){
      errors.subject = 'Required Filed';
      validate = false;
    } else {
      errors.subject = '';
      validate = true;
    }
    if(this.state.message.trim() === ''){
      errors.message = 'Required Filed';
      validate = false;
    } else {
      errors.message = '';
      validate = true;
    }
    this.setState({errors : errors})
    return validate
  }
  handleSubmit = (e) => {
    e.preventDefault();
    if (this.validateForm() && this.state.email.trim() && this.state.subject.trim() && this.state.message.trim()){
      if(this.state.subject.trim().length < 3){
        toast.error('The subject must be at least 3 characters.')
        return
      }
      if(this.state.subject.trim().message < 5){
        toast.error('The message must be at least 5 characters.')
        return
      }
      var requestObj = {
        email: this.state.email,
        subject: this.state.subject,
        message: this.state.message
      }
      axios.post(API_ROOT+`/api/v1/contacts`,
        requestObj
      )
        .then(function (response) {
          toast.success('successfully send.')
        })
        .catch(function (error) {
          if(error && error.response && error.response.status === 422){
            var error = error.response.data.errors;
            for(var key in error){
              toast.error(error[key][0])
            }
          } else {
            toast.error('an error occured.')
          }
        });
    }
  }
  render() {
    return (
      <Layout pageInfo={{ pageName: "contact" }}>
        <SEO title="Contact us" />
        <img className={'fullwidth'} src={aboutImg} alt="contact us"/>
        <Container fluid className={'inline-pages'}>
          <Row>
            <Col className={'p0 col-10 offset-1'} md={{span:10, offset:1}} >
              <p className={'bread-crumb'}>
                <Link to="/" className="link-no-style">
                  &nbsp;home&nbsp;
                </Link>/ contact us
              </p>
            </Col>
            <Col className={'inline-pages-content-box  col-10 offset-1'} md={{span:10, offset:1}} sm={{span:10, offset:1}}>
              <div className={'contact-top-section row-fluid'}>
                <Col md={{span:10, offset:1}} sm={{span:10, offset:1}}>
                    <Row>
                      <Col className={'contact-form-card'} lg={4} md={5}>
                        <form onSubmit={this.handleSubmit}>
                          <Row>
                            <Col className={'mb20'} md={{span:10, offset:1}}>
                              <Form.Group>
                                <Form.Control
                                    type="text"
                                    placeholder="Your mail"
                                    name={"email"}
                                    value={this.state.email}
                                    onChange={this.handleInputChange}
                                    className={this.state.errors.email !== '' ? "has-error" : ''}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col className={'mb20'} md={{span:10, offset:1}}>
                              <Form.Group>
                                <Form.Control
                                    type="text"
                                    placeholder="Subject"
                                    name={"subject"}
                                    value={this.state.subject}
                                    onChange={this.handleInputChange}
                                    className={this.state.errors.subject !== '' ? "has-error" : ''}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col className={'mb20'} md={{span:10, offset:1}}>
                              <Form.Group>
                                <Form.Control
                                    as={'textarea'}
                                    rows={'4'}
                                    type="text"
                                    placeholder="Message"
                                    name={"message"}
                                    value={this.state.message}
                                    onChange={this.handleInputChange}
                                    className={this.state.errors.message !== '' ? "has-error" : ''}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col className={'pointer'} md={{span:10, offset:1}}>
                              <button type='submit' className={'contact-btn text-white'} onClick={this.handleSubmit}>Send Request</button>
                            </Col>
                          </Row>
                        </form>
                      </Col>
                      <Col className={'contact-address'} lg={8} md={7}>
                        <p className={'contact-title-left'}>Contact us</p>
                        <p className={'sections-title-left-border'}></p>
                        <Col className={'p0 mt50 info'} md={12}>
                          <p>{this.state.address}</p>
                          <Row>
                            <div className={'contact-info'}>Manager:</div>
                            <Col>
                              {this.state.manager}
                            </Col>
                          </Row>
                          <Row>
                              <div className={'contact-info'}>Mob:</div>
                              <Col>
                                {this.state.mobile && this.state.mobile.map((e, i) => (
                                    <p key={i}>{e}</p>
                                ))}
                              </Col>
                          </Row>
                          <Row>
                            <div className={'contact-info'}>Tel:</div>
                            <Col>
                              {this.state.phone && this.state.phone.map((e, i) => (
                                  <p key={i}>{e}</p>
                              ))}
                            </Col>
                          </Row>
                          <Row>
                            <div className={'contact-info'}>Email:</div>
                            <Col>
                              {this.state.companyEmail && this.state.companyEmail.map((e, i) => (
                                  <p key={i}>{e}</p>
                              ))}
                            </Col>
                          </Row>
                        </Col>
                      </Col>
                    </Row>
                </Col>
              </div>
              <Row>
                <Col md={'12'}>
                  <div className="mapouter">
                    <div className="gmap_canvas">
                      <iframe width="100%" height="100%" id="gmap_canvas" title="mapFrame"
                              src={this.state.mapSrc}
                              frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"></iframe>
                      <a href="https://www.emojilib.com"></a>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Layout>
    )
  }
}
export default contactPage
